<!-- Window Content — always in DOM so router-outlet is available when route activates -->
<div [class.is-app-hidden]="!isLoaded">
    <router-outlet #outlet [class]="appClasses"></router-outlet>
    <!-- Custom CSS -->
    <div *ngIf="styles" ras-inject-content [styles]="styles"></div>
    <!-- Loading bar -->
    <ngx-loading-bar
        [color]="colorPrimary"
        height="4px"
        [includeSpinner]="false"
    ></ngx-loading-bar>
</div>

<!-- Initial blank loading container -->
<div *ngIf="!isLoaded" id="initial-loading-container"></div>

<ras-modal
    [configuration]="{
        modalId: 'app-modal'
    }"
></ras-modal>
